import { CdrFilters } from '@reliance/types/filters/CdrFilters';
import { Cdr } from '@reliance/types/models/Cdr';
import { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';

export const useCdrs = (filters: CdrFilters) => {
  return useAsync<PaginatedResponse<Cdr>>(
    () => api.get<PaginatedResponse<Cdr>>('/cdr', { params: filters }).then(r => r.data),
    [filters]
  );
};

type InmateCdrFilters = PaginationFilters & {
  inmateId?: number;
  callTypes?: string;
  sourceIds?: string;
  destinations?: string;
  facilityId?: number;
};

export const useCdrsByInmateId = (
  inmateId: number | null | undefined,
  filters?: InmateCdrFilters
) => {
  return useAsync<PaginatedResponse<Cdr>>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      const params: InmateCdrFilters = {
        inmateId: id,
        ...filters,
      };

      return api
        .get<PaginatedResponse<Cdr>>('/cdr', { params })
        .then((r) => r.data);
    },
    // Use empty array when inmateId is null to prevent auto-execution (for manual control)
    inmateId === null ? [] : [inmateId, filters]
  );
};

export const useCdrsBySourcePhone = (
  sourcePhone: string | null | undefined,
  filters?: CdrFilters
) => {
  return useAsync<PaginatedResponse<Cdr>>(
    (currentSourcePhone?: string | null | undefined, currentFilters?: CdrFilters) => {
      const phone = currentSourcePhone !== undefined ? currentSourcePhone : sourcePhone;
      if (phone == null || phone === '') {
        return null;
      }

      const resolvedFilters = currentFilters !== undefined ? currentFilters : filters;
      const params: CdrFilters = {
        ...resolvedFilters,
        sourceIds: phone,
      };

      return api.get<PaginatedResponse<Cdr>>('/cdr', { params }).then((r) => r.data);
    },
    sourcePhone === null ? [] : [sourcePhone]
  );
};